import { datatableDelete, datatableDeleteHover, datatableEdit, datatableEditHover } from 'assets/icons'
import ActiveDeactiveDialogConfirmation from 'components/ActiveDeactiveDialogConfirmation'
import UploadApproval from 'components/UploadApproval'
import moment from 'moment'
import { FilterMatchMode } from 'primereact/api'
import { Button } from 'primereact/button'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'
import { InputTextarea } from 'primereact/inputtextarea'
import { Sidebar } from 'primereact/sidebar'
import { Tag } from 'primereact/tag'
import { classNames } from 'primereact/utils'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { toast, ToastContent } from 'react-toastify'
import { handleLoader, handleNotFound } from 'redux/counterSlice'
import { approveRejectApi, deleteUserDocApi, getFileProcessing } from 'services/documentApprovalService'
import { black_listed_word, delete_black_listed_words, get_all_black_listed_word, get_black_listed_word_by_id, update_black_listed_word } from 'services/voiceInteractionService'

const BlackListedWords = () => {
    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        clearErrors
    } = useForm();
    const [userList, setUserList] = useState<any>()
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [id, setId] = useState<number>();
    const [filters, setFilters] = useState<any>(null);
    const [deleteWords, setDeleteWords] = useState<{ black_listed_words: [] }>({ "black_listed_words": [] })
    const [showDeleteDialogBox, setShowDeleteDialogBox] = useState(false);
    const [is_edit, setIs_edit] = useState<string>("");
    const [first, setFirst] = useState(0); // State to control the first page
    const [sortField, setSortField] = useState(""); // State to control the first page
    const [sortOrder, setSortOrder] = useState<any>(""); // State to control the first page
    const [rowsPerPage, setRowsPerPage] = useState(5); // State to control the rows per page

    // const [deleteItems, setDeleteItems] = useState<{
    //     id: number;
    //     is_approve: string;
    //     updated_by: string;
    // }>();
    const [selectedProducts, setSelectedProducts] = useState<any>(null);
    const params = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const fetchBlacklistwordsData = async () => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await get_all_black_listed_word()
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result?.error
            }
            dispatch(handleLoader(false));
            setUserList(result.reverse())
        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    // const onClear = () => {
    //     setShowDeleteDialogBox(false);
    //     setSelectedProducts(null);
    //     setDeleteUserDoc({ "id": [], deleted_by: "" });
    //     setDeleteDoc(false)
    // }
    const handleSort = (event: any) => {
        setSortField(event.sortField)
        setSortOrder(event.sortOrder)
        setFirst(0);  //Move to page 1
        // dispatch(setFirstVoice(0)); // Move to page 1
    };
    const onGlobalFilterChange = (e: any) => {
        setFirst(0);
        const value = e?.target?.value;
        setGlobalFilterValue(value);
        let _filters = { ...filters };

        _filters['global']!.value = value;

        setFilters(_filters);

    };

    const onClear = () => {
        setShowDeleteDialogBox(false);
        setSelectedProducts(null);
        setDeleteWords({ "black_listed_words": [] });
        // setDeleteDoc(false)
    }


    // const onDeleteClick = ({ id }: { id: number }) => {
    //     setShowDeleteDialogBox(true)
    //     setDeleteUserDoc((prevState: any) => ({ ...prevState, id: [id], deleted_by: localStorage.getItem("username") }))
    // }


    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        setGlobalFilterValue('');
    };


    const deleteBlackListWord = ({ word }: { word: any }) => {
        // e.stopPropagation();
        setShowDeleteDialogBox(true)
        setDeleteWords((prevState: any) => ({ ...prevState, black_listed_words: [...prevState.black_listed_words, word] }))
    }

    const deleteBlackListWordList = (() => {
        // when user clicked on active all and deactive all 
        if (selectedProducts?.length > 0) {
            selectedProducts?.forEach((element: any) => {
                setDeleteWords((prevState: any) => ({ ...prevState, black_listed_words: [...prevState.black_listed_words, element.word] }))
            });
            setShowDeleteDialogBox(true)
        } else {
            toast.error("Please select at least one black listed word to delete", {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    })

    const deleteBlackListWordApi = async () => {
        dispatch(handleLoader(true));
        const body = {
            user_name: localStorage.getItem("username"),
            black_listed_words: deleteWords.black_listed_words
        }
        try {
            const { result, error } = await delete_black_listed_words(body)
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            dispatch(handleLoader(false));
            fetchBlacklistwordsData()
            toast.success(result.message, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
            onClear()
        } catch (error) {
            dispatch(handleLoader(false));
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    useEffect(() => {
        dispatch(handleNotFound(false))
        fetchBlacklistwordsData()
        initFilters()
    }, [])

    const [is_hover_Edit, setIs_hover_Edit] = useState<string>("");
    const [is_hover_Delete, setIs_hover_Delete] = useState<string>("");

    const [visible, setVisible] = useState<boolean>(false);
    const customHeader = (
        <div className="flex align-items-center gap-2">
            {is_edit !== "" ? 'Edit' : 'Add'} Black Listed Words
        </div>
    );
    // Add update part
    const getFormErrorMessage = (name: string) => {
        return errors[name] && <small className="p-error">{errors[name]?.message?.toString()}</small>
    }
    const fetchBlackListWordData = async (id: string) => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await get_black_listed_word_by_id(id)
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            dispatch(handleLoader(false));
            setVisible(true)
            setValue("black_listed_word", result.word)
            setIs_edit(id)
            // setValue("description", result.description)
        } catch (error) {
            dispatch(handleLoader(false));
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }
    const onSubmit = async (data: any) => {
        const createBy = localStorage.getItem("username")
        dispatch(handleLoader(true));

        try {
            let result;
            if (is_edit === "") {
                const body = {
                    user_name: localStorage.getItem("username"),
                    // black_listed_word : data.black_listed_word
                    ...data
                }
                const { result, error } = await black_listed_word(body)
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                toast.success(result.message, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
            } else if (is_edit !== "") {
                const body = {
                    updated_by: createBy!,
                    // client_env: "string",
                    object_id: is_edit,
                    ...data
                }
                const { result, error } = await update_black_listed_word(body)
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                toast.success(result.message, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })

            }
            setVisible(false)
            setIs_edit("");
            await fetchBlacklistwordsData();
            dispatch(handleLoader(false));
            setValue("black_listed_word", "");
        } catch (error) {
            dispatch(handleLoader(false));
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }
    const onCancel = () => {
        setValue("black_listed_word", "");
        setVisible(false);
        setIs_edit("");
        clearErrors();
    }

    return (
        <>
            <div className="datatable-wrapper">
                <div className='p-4 content-wrapper'>
                    <div className="switch-section user-management-section">
                        <div className='d-flex align-items-center justify-content-between flex-wrap mb-3 table-top-row'>
                            <h4 className="mb-0">Black Listed Words</h4>
                            <div className="d-flex justify-content-between align-items-center table-right-row">
                                <div className='d-flex align-items-center table-right-first'>
                                    <div className='d-flex align-items-center table-search mr-3 mt-1 mb-1'>
                                        <IconField iconPosition="right" className='user-input'>
                                            <InputIcon className="pi pi-search"></InputIcon>
                                            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search by black listed word" />
                                        </IconField>
                                    </div>
                                    <Button label="Add Black List Word" outlined icon="pi pi-plus" className='outline-icon-btn mr-3' onClick={() => setVisible(true)}></Button>
                                    {/* onClick={async () => {
                                        navigate('/admin/black-listed-words/add')
                                    }} */}
                                </div>
                                <div className='table-right-end mt-1 mb-1'>
                                    <Button className='outline-icon-btn grey-outline-btn delete-btn' outlined label='Delete' data-bs-toggle={(selectedProducts && selectedProducts !== null && selectedProducts.length !== 0) && "modal"} data-bs-target="#active-deactive" onClick={() => deleteBlackListWordList()}></Button>
                                    {/* <Button className='ml-2 btn btn-outline-warning' label='Inactive' data-bs-toggle={ selectedProducts !== null &&  "modal"} data-bs-target="#active-deactive" onClick={() => setDeleteUserList(false)}></Button> */}
                                </div>
                            </div>
                        </div>
                        <DataTable
                            selection={selectedProducts}
                            selectionPageOnly
                            onSelectionChange={(e: any) => { setSelectedProducts(e.value) }}
                            paginator
                            filters={filters}
                            globalFilterFields={["word"]}
                            first={first}
                            onPage={(e) => { setFirst(e.first); setRowsPerPage(e.rows) }}
                            rows={rowsPerPage}
                            sortField={sortField}
                            sortOrder={sortOrder}
                            sortMode="single"
                            onSort={handleSort}
                            rowsPerPageOptions={[5, 10, 25]}
                            stripedRows
                            value={userList}
                            tableStyle={{}} emptyMessage="No blacklisted word records found"
                        >
                            <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                            <Column header="User Name" field='created_by' sortable sortField='created_by' ></Column>
                            <Column
                                field="word"
                                header="Black listed words"
                                // body={(rowData) => (
                                //     <a href="#" onClick={() => openPDF(rowData.file_data)}>
                                //         {rowData.file_name}
                                //     </a>
                                // )}
                                sortable
                            />
                            <Column
                                header="Date/Time"
                                body={(rowData: any) => (moment(rowData.created_at).format('MMM DD, YYYY HH:mm:ss'))}
                                sortable
                                sortField='created_at'
                            >
                            </Column>
                            {/* <Column field="status" header="Status" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} body={(rowData) => (<Tag value={rowData.is_approved === "approve" ? 'Approved' : (rowData.is_approved === "reject" ? 'Rejected' : 'Pending')} severity={getSeverity(rowData.is_approved === "approve" ? 'Approved' : (rowData.is_approved === "reject" ? 'Rejected' : 'Pending'))} />)} /> */}
                            <Column
                                header="Action"
                                body={(rowData) =>
                                (<div className='d-flex'>
                                    <span className='mr-3' onClick={(e) => { e.stopPropagation(); fetchBlackListWordData(rowData._id) }} onMouseEnter={() => setIs_hover_Edit(rowData._id)} onMouseLeave={() => setIs_hover_Edit("")}>
                                        <img src={is_hover_Edit === rowData._id ? datatableEditHover : datatableEdit} alt='edit-icon' />
                                    </span>
                                    {/* <i data-bs-toggle={rowData.is_approved !== "reject" && "modal"} data-bs-target="#upload-Approval" className={classNames('pi', { 'text-green-500 pi-check-circle': rowData.is_approved === "approve", 'text-red-500 pi-times-circle': rowData.is_approved === "reject", "fa-regular fa-hourglass-half justify-content-center text-primary": rowData.is_approved === "pending" })} onClick={(e) => { onStatusClick(e, rowData) }}></i> */}
                                    <span data-bs-toggle="modal" data-bs-target="#active-deactive" onClick={() => { deleteBlackListWord(rowData) }}
                                        onMouseEnter={() => setIs_hover_Delete(rowData._id)} onMouseLeave={() => setIs_hover_Delete("")}>
                                        <img src={is_hover_Delete === rowData._id ? datatableDeleteHover : datatableDelete} alt='delete-icon' />
                                    </span>
                                </div>)}>
                            </Column>
                        </DataTable>
                        <Sidebar position="right" header={customHeader} visible={visible} onHide={onCancel} className='form-sidebar'>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="form-sidebar-body">
                                    <div className='form-row'>
                                        <div className='form-col'>
                                            <label className="form-label">Black listed word<i>*</i></label>
                                            <InputText className="form-control " {...register("black_listed_word", { required: { value: true, message: "Black listed word is required" } })} placeholder={is_edit === "" ? "Add word" : "Edit Word"} />
                                            {getFormErrorMessage("black_listed_word")}
                                        </div>
                                    </div>
                                </div>
                                <div className='form-sidebar-footer'>
                                    <Button className='grey-outline-btn btn-lg' label='Cancel' type='button' onClick={onCancel}></Button>
                                    <Button className='outline-active-btn btn-lg' label='Save' type='submit'></Button>
                                </div>
                            </form>
                        </Sidebar>
                    </div>
                </div>
            </div>
            {/* <UploadApproval status={active} approveReject={approveReject} /> */}
            <ActiveDeactiveDialogConfirmation deletedoc={true} changeStatus={deleteBlackListWordApi} onCancel={onClear} />
        </>
    )
}

export default BlackListedWords